<!--
  WIP

  WIP
-->
<style lang="scss">
.v-checkbox {
  display: inline-block;
  user-select: none;
  outline: none;

  &__placeholder {
    cursor: pointer;
    width: 18px;
    height: 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: color(checkbox, bg);
    border: 1px solid color(checkbox, border);
    position: relative;
    overflow: hidden;
    margin-right: 10px;
  }

  &__input {
    position: absolute;
    left: -100px;
    top: -100px;
  }

  &__line {
    border-bottom:2px solid #000;
    width:20px;
    height:2px;
    align-self:center;
    margin-left:10px;
  }

  &__diamond {
    width: 0;
    height: 0;
    border: 8px solid transparent;
    border-bottom-color: black;
    position: relative;
    top: -8px;
    margin-left: 8px;

    &:after {
      content: '';
      position: absolute;
      left: -8px;
      top: 8px;
      width: 0;
      height: 0;
      border: 8px solid transparent;
      border-top-color: black;
    }
  }

  &__label {
    font-size: 14px;

    @screen md {
      font-size: 16px;
    }
  }
}
</style>

<template>
  <div
    class="v-checkbox"
    :class="{
      'v-checkbox--disabled': disabled,
      'v-checkbox--checked': checked,
      'v-checkbox--focused': focused
    }"
    :tabindex="disabled ? -1 : 0"
    role="checkbox"
    @click="toggle"
    @keydown.enter="focused = true; toggle($event)"
    @keydown.space="focused = true; toggle($event)"
    @blur="focused = false"
  >
    <div class="flex items-center">
      <div class="v-checkbox__placeholder">
        <input
          :disabled="disabled"
          type="checkbox"
          v-bind="$attrs"
          class="v-checkbox__input"
          :checked="checked"
          v-on="$listeners"
          @input="valueModel = $event.currentTarget.value"
        >
        <svg
          class="v-checkbox__check"
          width="12"
          height="9"
          viewBox="0 0 12 9"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.803 7.116L11.033 0 12 .95 3.803 9 0 5.265l.95-.95z"
            :fill="checked ? '#3A4456' : '#FFFFFF'"
            fill-rule="evenodd"
          />
        </svg>
      </div>
      <div class="v-checkbox__label mt-px">
        {{ label }}
      </div>
      <div
        :class="{ 'v-checkbox__line': !diamond, 'v-checkbox__diamond': diamond }"
        :style="indicatorStyle"
      />
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'VCheckbox',
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    line: {
      type: String,
      default: '',
    },
    diamond: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const checked = !!this.$attrs.checked;

    return {
      checked,
      focused: false,
    };
  },
  computed: {
    indicatorStyle() {
      if (this.diamond) {
        return {};
      }
      return {
        borderColor: this.line,
      };
    },
  },
  methods: {
    toggle(e) {
      if (this.disabled) {return;}
      this.checked = !this.checked;
      this.$emit('input', this.checked);
    },
  },
};
</script>
